module.exports = __webpack_public_path__ + "img/header-img3.051af7b2.png";